/**
 * Display-only upgrade of a legacy plain-text description to body HTML, so the
 * editor keeps its paragraph structure instead of collapsing newlines into one
 * line. Mirrors downstroke's `@punchup/utils/rich-text/plain-text-to-body-html`
 * (`seedBodyHtml`), the rule every Punchup reader applies to the same field.
 */

/** A recognized body/inline vocabulary tag — not "any letter after `<`", so a
 *  legacy row like `ask for <John>` or `price < $10` still reads as plain text. */
const BODY_HTML_TAG_RE = /<\/?(?:p|br|b|strong|i|em|u|a|span|ul|ol|li|blockquote|h[1-6]|div)(?:\s|>|\/)/i;

const escapeText = (value: string): string => value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

/** Blank line → new `<p>`, newline → `<br>`, text escaped. */
export const plainTextToBodyHtml = (text: string): string =>
	text
		.split(/\n{2,}/)
		.map((block) => block.trim())
		.filter((block) => block !== '')
		.map((block) => `<p>${block.split(/\n/).map(escapeText).join('<br>')}</p>`)
		.join('');

/** Markup passes through; a legacy plain-text value is escaped and upgraded. */
export const seedBodyHtml = (value: string): string =>
	!value || BODY_HTML_TAG_RE.test(value) ? value : plainTextToBodyHtml(value);
